import type IDocument from '../../../models/press/document.model';

export class DocumentApiModel {
  public static mapToBusinessModel(apiModel: DocumentApiModel): IDocument {
    return {
      caption: apiModel.caption,
      url: apiModel.url,
    };
  }

  public caption!: string;
  public url!: string;
}
